import { render, staticRenderFns } from "./PolicySummary.vue?vue&type=template&id=407e7dd5"
import script from "./PolicySummary.vue?vue&type=script&lang=js"
export * from "./PolicySummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports